import { render, staticRenderFns } from "./ProjectsSection.vue?vue&type=template&id=100bedb4&scoped=true&"
import script from "./ProjectsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSection.vue?vue&type=style&index=0&id=100bedb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bedb4",
  null
  
)

export default component.exports